export interface RawTransactionDto {
  id: string
  referenceId: string
  type: {
    id: number
    name: string
  }
  state: {
    id: number
    name: string
  }
  comment: string
  date: string
  settlementDate: string
  client: {
    id: number
    name: string
  }
  wallet: {
    id: number
    name: string
  }
  tradingAccount: {
    id: number
    name: string
  }
  directionType: {
    id: number
    name: string
  }
  amount: number
  currency: {
    id: number
    name: string
  }
  currencyAmount: number
  rate: number
  paymentProvider: {
    id: number
    name: string
  }
  providerReference: string
  paymentProviderCurrency: {
    id: number
    name: string
  }
  createdDate: string
  updatedDate: string
  selected: boolean // for kendoo
}

export enum RawTransactionKey {
  type = 'type.name',
  reference = 'referenceId',
  rate = 'rate',
  date = 'date',
  state = 'state.name',
  amount = 'amount',
  wallet = 'wallet.name',
  client = 'client.name',
  currency = 'currency.id',
  comment = 'comment',
  directionType = 'directionType.name',
  paymentProvider = 'paymentProvider.name',
  tradingAccount = 'tradingAccount.name',
  currencyAmount = 'currencyAmount',
  paymentProviderCurrency = 'paymentProviderCurrency.id',
  externalReference = 'externalReference',
  updatedDate = 'updatedDate',
  createdDate = 'createdDate',
}

export enum RawTransactionFilterKey {
  type = 'Type',
  wallet = 'WalletId',
  bonusTransactionStatusId = 'BonusTransactionStatusId',
  state = 'State',
}
